export const ACTION_MODAL_ACTION_BTN_TEST_ID = 'action-modal-action-btn';
export const ACTION_MODAL_CLOSE_BTN_TEST_ID = 'action-modal-close-btn';

export const FORM_MODAL_SUBMIT_BTN_TEST_ID = 'form-modal-submit-btn';
export const FORM_MODAL_CLOSE_BTN_TEST_ID = 'form-modal-close-btn';

export const ADD_CC_BTN_TEST_ID = 'add-cc-btn-test-id';
export const DELETE_CC_BUTTON_TEST_ID = 'delete-cc-btn-test-id';
export const SEND_OUT_EMAILS_MODAL_TEST_ID = 'send-out-emails-modal-test-id';
export const EMAILS_UNIQUENESS_ERROR_TEST_ID = 'emails-uniqueness-error-test-id';
